import { Button, Form, message, Upload } from "antd";
import { TrashIcon, UploadIcon } from "../../asset";
import style from './Dragger.module.css'
import _ from "lodash"
import { useEffect, useState } from "react";

const Dragger = (props) => {
	const [loadingFile, setLoadingFile] = useState(false);
	const [errorSize, setErrorSize] = useState("");
	const [fileUrl, setFileUrl] = useState("");

	const _receiveFile = (e) => {
		var files = e.fileList;
		_.map(files, (v) => {
			if (v.size > 3000000) {
				return message.error("File size must be less than 3 mb");
			} else {
				var arr = Array.from(files);
				props.setSelectedFileList(arr);
				let reader = new FileReader();
				reader.onload = () => {
					return reader.result;
				};
			}
		});
	};

	const convertBytesToKilobytes = (prevSize) => {
		let newSize = prevSize * 0.0009765625;
		return newSize.toFixed(3);
	};

	const fileFunc = () => {
		props.setSelectedFileList("");
		setFileUrl(null);
		setErrorSize(false);
	};

	return (
		<>
			<div className="">
				{props.selectedFileList?.length >= 1 && (
					<div
						style={{
							border: "dashed 1px #CACCCF",
							width: "100%",
							padding: "20px 25px 0px 25px",
						}}
					>
						<div className={style.ContainerLuarFile} style={{ width: "auto" }}>
							<div style={{ position: "relative" }}>
								<Button
									className={style.ButtonClose}
								></Button>

								<div className={style.ContainerFile}>
									<img
										src={typeof props.selectedFileList === 'string' ? props.selectedFileList : URL.createObjectURL(props.selectedFileList[0].originFileObj)}
										alt="img"
										style={{
											height: "40px",
											marginRight: "10px",
										}}
									/>
									<div>
										<div
											style={{
												fontSize: "16px",
												lineHeight: "18.75px",
											}}
										>
											{props.selectedFileList[0].name}
										</div>
										<div
											style={{
												fontSize: "12px",
												lineHeight: "14px",
												marginTop: "3px",
											}}
											hidden={false}
										>
											{convertBytesToKilobytes(props.selectedFileList[0].size)} KB
										</div>
									</div>
									<img
										src={TrashIcon}
										alt="img"
										onClick={(e) => fileFunc(e)}
										style={{
											marginLeft: "10px",
											cursor: "pointer",
										}}
									/>
								</div>
							</div>
						</div>
					</div>
				)}
				<Form.Item
					className={style.FormItemUpload}
					name="file"
					getValueFromEvent={(e) => _receiveFile(e)}
					hidden={props.selectedFileList?.length >= 1}
					valuePropName="fileList"
					style={{
						border: "dashed 1px #CACCCF",
						justifyContent: "center",
						padding: "0px 50px 0pxpx 50px",
					}}
				>
					<Upload
						name="file"
						multiple={false}
						beforeUpload={false}
						accept={".png, .jpg, .jpeg"}
						maxCount={1}
					>
						<div
							style={{
								rowGap: "10px",
								width: "499px",
								padding: "24px 150px 24px 150px",
							}}
						>
							<img
								src={UploadIcon}
								alt="upload"
								className="h-[70px] w-[193px]"
							/>
						</div>
					</Upload>
				</Form.Item>
			</div>
		</>
	);
};
export default Dragger;